/*-----------------------------------------------------------------------------*/
/* Custom Theme JS */
/*-----------------------------------------------------------------------------*/

(function () {
  var replacementHtml = '<p>If there is a special item you are looking for, we would love to help.</p><p>Monday-Friday 10:00am to 6:00pm</p><p>Saturday 11:00am to 5:00pm</p><p>Closed on Sundays</p>';
  var scrollCssId = 'pegaso-category-scroll-style';
  var collectionListCssId = 'pegaso-collection-list-style';
  var categoryHandles = {
    'New Arrivals': 'new-arrivals-1',
    'Lighting': 'lighting',
    'Tables': 'tables',
    'Seating': 'seating'
  };
  var collectionHeroImages = {
    'case-goods': 'https://cdn.shopify.com/s/files/1/0586/0370/0419/collections/cabinets-storage-category-hero.png?v=1782153858',
    'tables': 'https://cdn.shopify.com/s/files/1/0586/0370/0419/files/tables-category-hero-v2.png?v=1782152888',
    'seating': 'https://cdn.shopify.com/s/files/1/0586/0370/0419/files/seating-category-hero.png?v=1782149340',
    'lighting': 'https://cdn.shopify.com/s/files/1/0586/0370/0419/files/lighting-category-hero-v2.png?v=1782152897',
    'mirrors': 'https://cdn.shopify.com/s/files/1/0586/0370/0419/files/mirrors-category-hero-v2.png?v=1782152908',
    'fine-art': 'https://cdn.shopify.com/s/files/1/0586/0370/0419/files/fine-art-category-hero.png?v=1782149374'
  };

  function normalizeAskUsFooter() {
    var footerNavs = document.querySelectorAll('.footer .footer-nav');

    footerNavs.forEach(function (nav) {
      var title = nav.querySelector('.footer-nav__title');
      var textBlock = nav.querySelector('.footer-nav__text');
      var titleText = title ? (title.textContent || '').trim().toLowerCase() : '';
      var bodyText = textBlock ? (textBlock.textContent || '').trim().toLowerCase() : '';
      var isAskUs = titleText.indexOf('ask us') !== -1 || bodyText.indexOf('original furniture') !== -1;

      if (!isAskUs) return;

      if (!textBlock) {
        textBlock = document.createElement('div');
        textBlock.className = 'footer-nav__text rte';
        nav.appendChild(textBlock);
      }

      if (textBlock.innerHTML !== replacementHtml) {
        textBlock.innerHTML = replacementHtml;
      }
    });
  }

  function watchAskUsFooter() {
    var footer = document.querySelector('.footer');
    if (!footer || typeof MutationObserver === 'undefined') return;

    var observer = new MutationObserver(function () {
      normalizeAskUsFooter();
    });

    observer.observe(footer, { childList: true, subtree: true, characterData: true });
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function injectCategoryScrollCss() {
    if (document.getElementById(scrollCssId)) return;

    var style = document.createElement('style');
    style.id = scrollCssId;
    style.textContent =
      '@media screen and (min-width: 768px) {' +
      '.pegaso-curated-category {' +
      'position:relative;' +
      '}' +
      '.pegaso-curated-category .pegaso-curated-grid {' +
      'display:flex !important;' +
      'flex-wrap:nowrap !important;' +
      'gap:0 !important;' +
      'overflow-x:auto !important;' +
      'overflow-y:hidden !important;' +
      'padding:0 54px 18px !important;' +
      'scroll-behavior:smooth;' +
      'scroll-snap-type:x proximity;' +
      '-webkit-overflow-scrolling:touch;' +
      '}' +
      '.pegaso-curated-category .pegaso-curated-card {' +
      'flex:0 0 25% !important;' +
      'max-width:25% !important;' +
      'padding-left:16px !important;' +
      'padding-right:16px !important;' +
      'scroll-snap-align:start;' +
      '}' +
      '.pegaso-curated-category .pegaso-curated-grid::-webkit-scrollbar {' +
      'height:8px;' +
      '}' +
      '.pegaso-curated-category .pegaso-curated-grid::-webkit-scrollbar-track {' +
      'background:rgba(170, 136, 88, 0.14);' +
      '}' +
      '.pegaso-curated-category .pegaso-curated-grid::-webkit-scrollbar-thumb {' +
      'background:rgba(126, 95, 54, 0.45);' +
      'border-radius:999px;' +
      '}' +
      '.pegaso-scroll-controls {' +
      'display:flex;' +
      'align-items:center;' +
      'justify-content:center;' +
      'gap:12px;' +
      'margin:-4px 0 18px;' +
      '}' +
      '.pegaso-scroll-hint {' +
      'color:#8f6a43;' +
      'font-size:11px;' +
      'letter-spacing:0.16em;' +
      'text-transform:uppercase;' +
      '}' +
      '.pegaso-scroll-button {' +
      'width:42px;' +
      'height:42px;' +
      'border:1px solid rgba(143,106,67,0.42);' +
      'border-radius:999px;' +
      'background:#fffdf9;' +
      'color:#17120f;' +
      'cursor:pointer;' +
      'font-size:24px;' +
      'line-height:1;' +
      'box-shadow:0 10px 22px rgba(27,20,15,0.08);' +
      '}' +
      '.pegaso-scroll-button:hover,' +
      '.pegaso-scroll-button:focus {' +
      'background:#17120f;' +
      'border-color:#17120f;' +
      'color:#fbf8f3;' +
      '}' +
      '}' +
      '@media screen and (min-width: 768px) and (max-width: 980px) {' +
      '.pegaso-curated-category .pegaso-curated-card {' +
      'flex-basis:33.333% !important;' +
      'max-width:33.333% !important;' +
      '}' +
      '.pegaso-curated-category .pegaso-curated-grid {' +
      'padding-left:46px !important;' +
      'padding-right:46px !important;' +
      '}' +
      '}' +
      '@media screen and (max-width: 767px) {' +
      '.pegaso-scroll-controls {' +
      'display:flex;' +
      'align-items:center;' +
      'justify-content:center;' +
      'gap:10px;' +
      'margin:2px 0 16px;' +
      '}' +
      '.pegaso-scroll-hint {' +
      'color:#8f6a43;' +
      'font-size:10px;' +
      'letter-spacing:0.14em;' +
      'text-transform:uppercase;' +
      '}' +
      '.pegaso-scroll-button {' +
      'width:38px;' +
      'height:38px;' +
      'border:1px solid rgba(143,106,67,0.42);' +
      'border-radius:999px;' +
      'background:#fffdf9;' +
      'color:#17120f;' +
      'font-size:22px;' +
      'line-height:1;' +
      'box-shadow:0 8px 18px rgba(27,20,15,0.08);' +
      '}' +
      '}';

    document.head.appendChild(style);
  }

  function injectCollectionListCss() {
    if (document.getElementById(collectionListCssId)) return;

    var style = document.createElement('style');
    style.id = collectionListCssId;
    style.textContent =
      '.section--list-collections .collection-list {' +
      'row-gap:28px;' +
      '}' +
      '.section--list-collections .collection-list__link {' +
      'display:block;' +
      'height:100%;' +
      'text-decoration:none;' +
      '}' +
      '.section--list-collections .collection-list__item {' +
      'position:relative;' +
      'height:clamp(280px, 33vw, 460px);' +
      'overflow:hidden;' +
      'border:1px solid rgba(126, 95, 54, 0.22);' +
      'background:#efe7dc;' +
      'box-shadow:0 16px 34px rgba(27, 20, 15, 0.08);' +
      '}' +
      '.section--list-collections .collection-list__bg {' +
      'width:100%;' +
      'height:100%;' +
      'object-fit:cover;' +
      'object-position:center;' +
      'transform:scale(1.015);' +
      'filter:saturate(0.92) contrast(0.96) brightness(0.98);' +
      'transition:transform 420ms ease, filter 420ms ease;' +
      '}' +
      '.section--list-collections .collection-list__link:hover .collection-list__bg,' +
      '.section--list-collections .collection-list__link:focus .collection-list__bg {' +
      'transform:scale(1.055);' +
      'filter:saturate(0.98) contrast(1) brightness(1);' +
      '}' +
      '.section--list-collections .collection-list__overlay {' +
      'background:linear-gradient(180deg, rgba(23,18,15,0.04) 0%, rgba(23,18,15,0.28) 100%) !important;' +
      'opacity:1 !important;' +
      '}' +
      '.section--list-collections .collection-list__title {' +
      'padding:24px;' +
      '}' +
      '.section--list-collections .collection-list__title-text {' +
      'color:#fffdf9;' +
      'font-size:clamp(19px, 2vw, 28px);' +
      'letter-spacing:0;' +
      'line-height:1.16;' +
      'text-shadow:0 2px 18px rgba(23,18,15,0.46);' +
      '}' +
      '@media screen and (max-width: 767px) {' +
      '.section--list-collections .collection-list {' +
      'row-gap:18px;' +
      '}' +
      '.section--list-collections .collection-list__item {' +
      'height:clamp(240px, 72vw, 360px);' +
      '}' +
      '.section--list-collections .collection-list__title {' +
      'padding:18px;' +
      '}' +
      '}';

    document.head.appendChild(style);
  }

  function renderCuratedCards(products) {
    return products.map(function (product) {
      return (
        '<article class="pegaso-curated-card">' +
        '<a class="pegaso-curated-card__link" href="' + escapeHtml(product.href) + '">' +
        '<div class="pegaso-curated-card__media">' + product.mediaHtml + '</div>' +
        '<div class="pegaso-curated-card__body">' +
        '<h3 class="pegaso-curated-card__title">' + escapeHtml(product.title) + '</h3>' +
        '<div class="pegaso-curated-card__price">' + product.priceHtml + '</div>' +
        '</div>' +
        '</a>' +
        '</article>'
      );
    }).join('');
  }

  function findCategoryHandle(section) {
    var explicitHandle = section.getAttribute('data-pegaso-collection');
    if (explicitHandle) return explicitHandle;

    var titleNode = section.querySelector('.section__title-text');
    var title = titleNode ? titleNode.textContent.trim() : '';
    return categoryHandles[title] || '';
  }

  function addScrollControls(section, grid) {
    if (section.querySelector('.pegaso-scroll-controls')) return;

    var controls = document.createElement('div');
    controls.className = 'pegaso-scroll-controls';
    controls.innerHTML =
      '<button class="pegaso-scroll-button pegaso-scroll-button--prev" type="button" aria-label="Scroll previous pieces">‹</button>' +
      '<span class="pegaso-scroll-hint">Scroll for more</span>' +
      '<button class="pegaso-scroll-button pegaso-scroll-button--next" type="button" aria-label="Scroll next pieces">›</button>';

    var title = section.querySelector('.section__title');
    if (title) {
      title.insertAdjacentElement('afterend', controls);
    } else {
      grid.insertAdjacentElement('beforebegin', controls);
    }

    controls.querySelector('.pegaso-scroll-button--prev').addEventListener('click', function () {
      grid.scrollBy({ left: -Math.max(grid.clientWidth * 0.85, 320), behavior: 'smooth' });
    });

    controls.querySelector('.pegaso-scroll-button--next').addEventListener('click', function () {
      grid.scrollBy({ left: Math.max(grid.clientWidth * 0.85, 320), behavior: 'smooth' });
    });
  }

  function extendCategoryScrollRows() {
    injectCategoryScrollCss();

    document.querySelectorAll('.pegaso-curated-category').forEach(function (section) {
    var grid = section ? section.querySelector('.pegaso-curated-grid') : null;
      var handle = section ? findCategoryHandle(section) : '';
      if (!grid || !handle || grid.getAttribute('data-pegaso-scroll-ready') === 'true') return;

      addScrollControls(section, grid);

      fetch('/collections/' + handle + '?sort_by=created-descending', { credentials: 'same-origin' })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var seen = {};
        var products = [];

        doc.querySelectorAll('.product').forEach(function (productNode) {
          if (products.length >= 12) return;

          var link = productNode.querySelector('a.product-link');
          var media = productNode.querySelector('.product__media');
          var title = productNode.querySelector('.product__title');
          var price = productNode.querySelector('.product__price');

          if (!link || !title || seen[link.href]) return;

          seen[link.href] = true;
          products.push({
            href: link.getAttribute('href') || link.href,
            title: title.textContent.trim(),
            priceHtml: price ? price.innerHTML : '',
            mediaHtml: media ? media.outerHTML : ''
          });
        });

          if (products.length > 4) {
          grid.innerHTML = renderCuratedCards(products);
            addScrollControls(section, grid);
        }

        grid.setAttribute('data-pegaso-scroll-ready', 'true');
      })
      .catch(function () {
        grid.setAttribute('data-pegaso-scroll-ready', 'true');
      });
    });
  }

  function removeDecorativeObjectsBubble() {
    return;
  }

  function removeDecorativeObjectsProductSection() {
    if (window.location.pathname !== '/') return;

    document.querySelectorAll('.section, .shopify-section').forEach(function (section) {
      var title = section.querySelector('.section__title-text, h2, h1');
      var titleText = title ? title.textContent.replace(/\s+/g, ' ').trim().toLowerCase() : '';
      var isProductSection = section.querySelector('.home-products, .pegaso-curated-grid, .product, .pegaso-curated-card');
      var isBubbleSection = section.querySelector('.pegaso-category-bubbles');

      if (isProductSection && !isBubbleSection && titleText.indexOf('decorative objects') !== -1) {
        section.remove();
      }
    });
  }

  function applyCollectionListHeroImages() {
    injectCollectionListCss();

    document.querySelectorAll('.collection-list__link[href*="/collections/"]').forEach(function (link) {
      var match = (link.getAttribute('href') || '').match(/\/collections\/([^?#/]+)/);
      var handle = match ? match[1] : '';
      var imageUrl = collectionHeroImages[handle];
      var item = link.querySelector('.collection-list__item');
      var image = link.querySelector('.collection-list__bg');

      if (item) {
        item.style.backgroundColor = '#efe7dc';
      }

      if (!imageUrl || !item) return;

      item.style.backgroundImage = 'url("' + imageUrl + '")';
      item.style.backgroundPosition = 'center';
      item.style.backgroundSize = 'cover';
      item.style.backgroundColor = '#efe7dc';

      if (image && image.tagName === 'IMG') {
        image.src = imageUrl;
        image.removeAttribute('srcset');
        image.alt = (link.textContent || '').trim();
        image.style.objectFit = 'cover';
        image.style.objectPosition = 'center';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      normalizeAskUsFooter();
      extendCategoryScrollRows();
      removeDecorativeObjectsBubble();
      removeDecorativeObjectsProductSection();
      applyCollectionListHeroImages();
      watchAskUsFooter();
      setTimeout(normalizeAskUsFooter, 400);
      setTimeout(extendCategoryScrollRows, 500);
      setTimeout(removeDecorativeObjectsBubble, 600);
      setTimeout(removeDecorativeObjectsProductSection, 625);
      setTimeout(applyCollectionListHeroImages, 650);
      setTimeout(normalizeAskUsFooter, 1200);
      setTimeout(extendCategoryScrollRows, 1300);
      setTimeout(removeDecorativeObjectsBubble, 1400);
      setTimeout(removeDecorativeObjectsProductSection, 1425);
      setTimeout(applyCollectionListHeroImages, 1450);
      setTimeout(normalizeAskUsFooter, 2400);
      setTimeout(extendCategoryScrollRows, 2500);
      setTimeout(removeDecorativeObjectsBubble, 2600);
      setTimeout(removeDecorativeObjectsProductSection, 2625);
      setTimeout(applyCollectionListHeroImages, 2650);
    });
  } else {
    normalizeAskUsFooter();
    extendCategoryScrollRows();
    removeDecorativeObjectsBubble();
    removeDecorativeObjectsProductSection();
    applyCollectionListHeroImages();
    watchAskUsFooter();
    setTimeout(normalizeAskUsFooter, 400);
    setTimeout(extendCategoryScrollRows, 500);
    setTimeout(removeDecorativeObjectsBubble, 600);
    setTimeout(removeDecorativeObjectsProductSection, 625);
    setTimeout(applyCollectionListHeroImages, 650);
    setTimeout(normalizeAskUsFooter, 1200);
    setTimeout(extendCategoryScrollRows, 1300);
    setTimeout(removeDecorativeObjectsBubble, 1400);
    setTimeout(removeDecorativeObjectsProductSection, 1425);
    setTimeout(applyCollectionListHeroImages, 1450);
    setTimeout(normalizeAskUsFooter, 2400);
    setTimeout(extendCategoryScrollRows, 2500);
    setTimeout(removeDecorativeObjectsBubble, 2600);
    setTimeout(removeDecorativeObjectsProductSection, 2625);
    setTimeout(applyCollectionListHeroImages, 2650);
  }

  window.addEventListener('load', function () {
    normalizeAskUsFooter();
    extendCategoryScrollRows();
    removeDecorativeObjectsBubble();
    removeDecorativeObjectsProductSection();
    applyCollectionListHeroImages();
    setTimeout(normalizeAskUsFooter, 600);
    setTimeout(extendCategoryScrollRows, 700);
    setTimeout(removeDecorativeObjectsBubble, 800);
    setTimeout(removeDecorativeObjectsProductSection, 825);
    setTimeout(applyCollectionListHeroImages, 850);
  });
})();
